function cleanBaseUrl(value) {
  return String(value || "").replace(/\/+$/, "");
}

export const MYKYC_API_BASE = cleanBaseUrl(
  process.env.REACT_APP_MYKYC_API_BASE || "https://api.mykyc.cloud"
);

export const KYC_SUBMISSION_API_BASE = cleanBaseUrl(
  process.env.REACT_APP_KYC_SUBMISSION_API_BASE ||
    process.env.REACT_APP_MYKYC_API_BASE ||
    "https://api.mykyc.cloud"
);

export const MAIL_API_BASE = cleanBaseUrl(
  process.env.REACT_APP_MAIL_API_BASE || "https://node.naxero.online"
);
